export default __webpack_public_path__ + "img/b6cb46b8d19ba95d03a3ef57e0c45f3e.png";